import api from '../../api/userAPI';
import {
  setSuccessNotification,
  setErrorNotification
} from '../snackbarNotification';

export const ADD_BEGIN = 'customer.ops/ADD_BEGIN';
export const ADD_SUCCESS = 'customer.ops/ADD_SUCCESS';
export const ADD_FAILED = 'customer.ops/ADD_FAILED';
export const EDIT_BEGIN = 'customer.ops/EDIT_BEGIN';
export const EDIT_SUCCESS = 'customer.ops/EDIT_SUCCESS';
export const EDIT_FAILED = 'customer.ops/EDIT_FAILED';
export const DELETE_BEGIN = 'customer.ops/DELETE_BEGIN';
export const DELETE_SUCCESS = 'customer.ops/DELETE_SUCCESS';
export const DELETE_FAILED = 'customer.ops/DELETE_FAILED';

const addBegin = () => ({ type: ADD_BEGIN });
const addSuccess = () => ({ type: ADD_SUCCESS });
const addFailed = error => ({ type: ADD_FAILED, payload: error });
export const addCustomer = data => async dispatch => {
  dispatch(addBegin());

  const formattedData = {
    user_name: data.name,
    password: data.password,
    email: data.email,
    mobile: data.phone,
    birthdate: data.dateOfBirth
  };

  try {
    const res = await api.post('register-user', formattedData);

    dispatch(addSuccess());
    dispatch(setSuccessNotification('Successfully added data'));
  } catch (error) {
    dispatch(addFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const editBegin = () => ({ type: EDIT_BEGIN });
const editSuccess = () => ({ type: EDIT_SUCCESS });
const editFailed = error => ({ type: EDIT_FAILED, payload: error });
export const editCustomer = (id, data) => async dispatch => {
  dispatch(editBegin());

  const formattedData = {
    id,
    user_name: data.name,
    password: data.password,
    email: data.email,
    mobile: data.phone,
    birthdate: data.dateOfBirth,
    address: data.address
  };

  try {
    await api.post('update-user', formattedData);

    dispatch(editSuccess());
    dispatch(setSuccessNotification('Successfully edited data'));
  } catch (error) {
    dispatch(editFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const deleteBegin = () => ({ type: DELETE_BEGIN });
const deleteSuccess = () => ({ type: DELETE_SUCCESS });
const deleteFailed = error => ({ type: DELETE_FAILED, payload: error });
export const deleteCustomer = id => async dispatch => {
  dispatch(deleteBegin());

  const data = {
    id
  };

  try {
    const res = await api.delete(`delete-user`, { data });

    dispatch(deleteSuccess());
    dispatch(setSuccessNotification('Successfully deleted data'));
  } catch (error) {
    dispatch(deleteFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_BEGIN:
    case EDIT_BEGIN:
    case DELETE_BEGIN:
      return { ...state, completed: false, isLoading: true, error: null };

    case ADD_SUCCESS:
    case EDIT_SUCCESS:
    case DELETE_SUCCESS:
      return { ...state, completed: true, isLoading: false };

    case ADD_FAILED:
    case EDIT_FAILED:
    case DELETE_FAILED:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
};

export default reducer;

const initialState = {
  completed: false,
  isLoading: false,
  error: null
};
